import React from 'react';
import { Shield, Clock, Award, ThumbsUp } from 'lucide-react';

const FeatureSection: React.FC = () => {
  const features = [
    {
      icon: <Shield className="h-10 w-10" />,
      title: 'Licensed & Insured',
      description: 'We\'re fully licensed and insured for your protection and peace of mind.'
    },
    {
      icon: <Clock className="h-10 w-10" />,
      title: 'Reliable Service',
      description: 'Count on us to arrive on schedule, every time. Your time is valuable.'
    },
    {
      icon: <Award className="h-10 w-10" />,
      title: 'Expert Technicians',
      description: 'Our pool professionals have years of experience and extensive training.'
    },
    {
      icon: <ThumbsUp className="h-10 w-10" />,
      title: 'Satisfaction Guaranteed',
      description: 'Not happy? We\'ll make it right or you don\'t pay.'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-purple-900 mb-4">Why Choose Splash Right Pool Care?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">We deliver professional, reliable pool maintenance services you can trust.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="text-orange-500 mb-4 flex justify-center">{feature.icon}</div>
              <h3 className="text-xl font-bold text-purple-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;